import React from 'react'
import { useDispatch } from 'react-redux'

import { CONSTANTS, HELPER } from '../../../../utils'
import { cartActions } from '../../../../store/actions'

import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'

import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import ListItemText from '@mui/material/ListItemText'
import Select from '@mui/material/Select'
import Checkbox from '@mui/material/Checkbox'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
}

const names = [
	'Oliver Hansen',
	'Van Henry',
	'April Tucker',
	'Ralph Hubbard',
	'Omar Alexander',
	'Carlos Abbott',
	'Miriam Wagner',
	'Bradley Wilkerson',
	'Virginia Andrews',
	'Kelly Snyder',
]

const findCommonByKey = (arr1, arr2, key) => {
	var uniqueResultArrayObjOne = arr1.filter(function (objOne) {
		return arr2.some(function (objTwo) {
			return objOne[key] === objTwo[key]
		})
	})
	return uniqueResultArrayObjOne
}

const ProductOptions = ({ product, attribute, selectedOption }) => {
	const dispatch = useDispatch()
	const { options } = attribute
	//talha get updated variant (need to test)
	const { selected_variant, active_variants } = product

	const handleChangeOption = (option) => {
		//get matching attribute_options of updated option
		let updatedAtrr = product?.attribute_option.filter(
			(e) =>
				option.attribute_id === e.attribute_id &&
				(option.option_id === e.option_id || e.option_id === 0)
		)

		//get other selected options
		var getOtherOptions = selected_variant?.attributes.filter((e) => e.id !== selectedOption?.id)

		let variantDetails = []
		if (getOtherOptions?.length > 0) {
			//get matching attribute_options of previous selected option
			let otherArray = getOtherOptions
				?.map((e) => e?.options)
				?.map((option) => {
					if (
						product.attribute_option?.filter(
							(e) =>
								option.attribute_id === e.attribute_id &&
								(option.id === e.option_id || e.option_id === 0)
						)
					) {
						return product.attribute_option?.filter(
							(e) =>
								option.attribute_id === e.attribute_id &&
								(option.id === e.option_id || e.option_id === 0)
						)
					}
					return true
				})
			//find matching variant ids of all arrays
			let i = 0
			let testId = updatedAtrr
			while (i !== otherArray.length) {
				variantDetails = findCommonByKey(testId, otherArray[i], 'variant_id')
				i++
			}
			if (variantDetails.length > 1) {
				// variantDetails=variantDetails?.find(e => e?.option_id !== 0)?.variant_id
				let findInSelected = variantDetails
					.map((e) => e.variant_id)
					.includes(selected_variant?.variant_id)
				variantDetails = findInSelected
					? selected_variant?.variant_id
					: variantDetails?.find((e) => e?.option_id !== 0)?.variant_id
			} else if (variantDetails.length === 1) {
				variantDetails = variantDetails[0]?.variant_id
			}
		}
		//find matching variant id in active variants and update attributes
		const _variant = active_variants.find(
			(e) =>
				e.variant_id === (variantDetails.length === 0 ? updatedAtrr[0]?.variant_id : variantDetails)
		)
		//compare each options from selected_variants if matched then take else replace with currentObj
		let currentObj = [{ ...selectedOption, options: option }, ...getOtherOptions]
		let newData = _variant?.attributes.map((e) => {
			let matchingObj = currentObj.find((nm) => e.name === nm.name)
			return JSON.stringify(e) === JSON.stringify(matchingObj)
				? matchingObj
				: HELPER.isEmpty(e?.options)
				? matchingObj
				: e
		})
		let _variant_update = { ..._variant, attributes: newData }
		if (variantDetails) {
			dispatch(cartActions.SELECT_PRODUCT_VARIANT(product, _variant_update))
		}
	}
	return (
		<div className="sizeVar varBtns">
			{options.map((option) => {
				let found = product?.attribute_option.find(
					(e) =>
						e.attribute_id === option.attribute_id &&
						(e.option_id === option.option_id || e.option_id === 0)
				)
				let selected = selectedOption?.options?.option_value === option.option_value
				return found ? (
					<button
						className={`${selected ? 'selected' : ''} 
                                `}
						onClick={() => handleChangeOption(option)}
					>
						{option?.option_value}
					</button>
				) : (
					''
				)
			})}
		</div>
	)
}

const ProductAtrributes = ({ selected_product }) => {
	const { attribute, has_variants, selected_variant } = selected_product
	const [personName, setPersonName] = React.useState([])
	const handleChange = (event) => {
		const {
			target: { value },
		} = event
		setPersonName(
			// On autofill we get a stringified value.
			typeof value === 'string' ? value.split(',') : value
		)
	}
	const selectedVariantOptions = selected_variant.attributes
	return has_variants === CONSTANTS.YES && HELPER.isNotEmpty(attribute) ? (
		<div className="prodSelectVar mt-2">
			{attribute?.map((attr) => {
				let selectedAttrOption = selectedVariantOptions.find((selectedVariantOption) => {
					return selectedVariantOption.id === attr.id
				})
				return (
					<div className="prodSelectSize prodVar" key={`attribute-${attr.id}`}>
						<Accordion>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel1b-content"
								id="panel1b-header"
							>
								<div className="accHeader">
									{HELPER.titleCase(attr.name)}:
									<span>{selectedAttrOption?.options?.option_value}</span>
								</div>
							</AccordionSummary>
							<AccordionDetails>
								<ProductOptions
									product={selected_product}
									attribute={attr}
									selectedOption={selectedAttrOption}
								/>
							</AccordionDetails>
						</Accordion>
					</div>
				)
			})}
			<div className="prodSelectSize prodVar d-none">
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1b-content"
						id="panel1b-header"
					>
						<Typography>
							<div className="accHeader">
								Items: <span>Selected</span>
							</div>
						</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<Typography>
							<div className="selectBox">
								<FormControl>
									<InputLabel id="demo-multiple-checkbox-label">Select Option</InputLabel>
									<Select
										labelId="demo-multiple-checkbox-label"
										id="demo-multiple-checkbox"
										multiple
										value={personName}
										onChange={handleChange}
										input={<OutlinedInput label="Select Option" />}
										renderValue={(selected) => selected.join(', ')}
										MenuProps={MenuProps}
										variant="outline"
									>
										{names.map((name) => (
											<MenuItem key={name} value={name}>
												<Checkbox
													className="selectBoxCustomSvg"
													checked={personName.indexOf(name) > -1}
												/>
												<ListItemText className="selectBoxCustomField" primary={name} />
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</div>
						</Typography>
					</AccordionDetails>
				</Accordion>
			</div>
		</div>
	) : (
		''
	)
}

export default ProductAtrributes
